<div class="nim__content-area">
  <div class="h1">Sorry Spiderman, this is not a "web" app.</div>
  <img src="https://media1.giphy.com/media/12BxeGWS1AMTcs/giphy.gif" alt="Unsupported">
</div>

<div class="nim__sidebar">
  <div class="nim__sidebar__top"></div>
  <div class="nim__sidebar__bottom">
  </div>
  <div class="nim__sidebar__global">
    <div nc-global-navigation [isBackEnabled]="false" [isHomeEnabled]="false"></div>
  </div>
</div>